import keyMirror from 'keymirror';

export const DisableAccountActionTypes = keyMirror({
  DISABLE_ACCOUNT: undefined,
  DISABLE_ACCOUNT_SUCCESS: undefined,
  DISABLE_ACCOUNT_ERROR: undefined,
  DISABLE_ACCOUNT_CLEAR: undefined,
});
